import { RegisteredDetails } from "../components/RegisteredDetails";
import { RegisterLayout } from "../components/RegisterLayout";

const Section = ({ n, title, children }) => (
  <section className="py-8 border-b border-white/10" data-testid={`terms-section-${n}`}>
    <div className="grid md:grid-cols-[80px_1fr] gap-4 md:gap-10">
      <span className="font-serif text-3xl text-[#B87333]/40">{n}</span>
      <div>
        <h2 className="font-serif text-2xl md:text-3xl mb-4">{title}</h2>
        <div className="font-body text-[#C9C9C2] leading-relaxed space-y-3 max-w-2xl">{children}</div>
      </div>
    </div>
  </section>
);

export default function Terms() {
  return (
    <RegisterLayout
      kicker="/ Legal"
      title="Terms of Sale"
      subtitle={`These Terms of Sale govern orders placed with Vinci Inc. through this website. By placing an order you agree to these terms. Last updated ${new Date().getFullYear()}.`}
    >
      <div className="mt-4">
        <Section n="01" title="The seller">
          <p>Orders are sold by <strong className="text-[#F5F5F0]">Vinci Inc.</strong> and its group of Private Limited, LLP, Partnership and Proprietorship entities operating PAN-India. The specific registered entity, its GSTIN and correspondence address applicable to your order are stated on the GST tax invoice issued for that order, based on the delivery state.</p>
        </Section>
        <Section n="02" title="Eligibility & accounts">
          <p>Orders may be placed only by registered, verified buyers (Super-Stockist, Wholesaler, Dealer or Booking Agent). You are responsible for the accuracy of your business details, GST number and for keeping your account secure.</p>
        </Section>
        <Section n="03" title="Pricing & tier discounts">
          <p>Prices are indicative and may change with prevailing market/daily rates until an order is confirmed. Applicable tier discounts and 18% GST are calculated and shown at checkout. The payable amount is the total displayed at the time of payment.</p>
        </Section>
        <Section n="04" title="Orders & acceptance">
          <p>An order is a request to purchase. A contract forms only when payment is successfully received and the order is confirmed by us. We may decline or cancel an order due to stock, pricing errors, or verification issues, in which case any amount paid is refunded.</p>
        </Section>
        <Section n="05" title="Payments">
          <p>Payments are processed securely via <strong className="text-[#F5F5F0]">Razorpay</strong> (UPI, cards, netbanking). We do not store full card details. Orders are dispatched only against confirmed payment unless separately agreed in writing.</p>
        </Section>
        <Section n="06" title="Delivery">
          <p>Delivery timelines are estimates and depend on material, quantity and destination. Risk passes to the buyer on delivery to the address provided. Tracking / LR details are shared once an order is dispatched. Please inspect goods on receipt and report visible damage immediately.</p>
        </Section>
        <Section n="07" title="Taxes & invoicing">
          <p>A GST tax invoice is issued for every confirmed order and is available to download from your account. Buyers are responsible for providing a correct GSTIN for input-credit purposes.</p>
        </Section>
        <Section n="08" title="Governing law">
          <p>These terms are governed by the laws of India, with exclusive jurisdiction of the courts at Mumbai, Maharashtra.</p>
        </Section>
        <Section n="09" title="Contact">
          <RegisteredDetails />
        </Section>
      </div>
    </RegisterLayout>
  );
}
